/**
 * Sorts games within each league section by match date (most recent first)
 */
function initAllGamesList() {
  function parseDate(dateString) {
    if (!dateString) return new Date(0);

    const parts = dateString.split('-');
    if (parts.length === 3) {
      return new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
    }

    return new Date(0);
  }

  function sortGamesByDate() {
    const leagueContainers = document.querySelectorAll('.all-games-list__items');

    leagueContainers.forEach((container) => {
      const gameElements = Array.from(container.querySelectorAll('[data-game-date]'));

      if (gameElements.length === 0) return;

      gameElements.sort((a, b) => {
        const dateA = parseDate(a.getAttribute('data-game-date'));
        const dateB = parseDate(b.getAttribute('data-game-date'));

        return dateA - dateB;
      });

      container.innerHTML = '';
      gameElements.forEach((element) => {
        container.appendChild(element);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sortGamesByDate);
  } else {
    sortGamesByDate();
  }

  setTimeout(sortGamesByDate, 100);
}

initAllGamesList();
